import { render, staticRenderFns } from "./ItemFormTable.vue?vue&type=template&id=20277516&"
import script from "./ItemFormTable.vue?vue&type=script&lang=js&"
export * from "./ItemFormTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports